<template>
  <v-container class="riiqosxn riiqosxn-five">
    <v-row class="row-vector-img">
      <v-col cols="12" md="7">
        <div class="vector-img"></div>
      </v-col>
      <v-col cols="12" md="5">
        <div class="google-ico">
          <h4 class="google-ico__title">Google Drive Meets Riiqo</h4>
          <!-- <div class="google-ico__row">
            <div class="google-ico__item googledrive">
              <h4 class="item-name">Google Drive Meets Riiqo</h4>
            </div>
          </div> -->
          <p>Store your Google Docs and Sheets in our drive for quick and easy access. It doesn’t stop there. You can click to edit them right from Riiqo and always see your Docs & Sheets up to date.</p>
          <div class="google-ico__row">
            <div class="google-ico__item">
              <div class="item-icon docs"></div>
            </div>
            <div class="google-ico__item">
              <div class="item-icon sheets"></div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'SxnFive',

  data: () => ({
    
  }),
};
</script>
